import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-mail-check-line text-2xl text-green-600"></i>
          </div>
          
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Check Your Email</h2>
          <p className="text-gray-600 mb-6">
            We've sent password reset instructions to <strong>{email}</strong>
          </p>
          
          <div className="space-y-4">
            <p className="text-sm text-gray-500">
              Didn't receive the email? Check your spam folder or try again.
            </p>
            
            <button
              onClick={() => setIsSubmitted(false)}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover-blue-700 focus-2 focus-blue-500 focus-offset-2 transition duration-200 font-medium whitespace-nowrap cursor-pointer"
            >
              Try Different Email
            </button>
            
            <Link
              to="/login"
              className="block w-full text-center bg-gray-100 text-gray-700 py-3 px-4 rounded-lg hover-gray-200 transition duration-200 font-medium whitespace-nowrap"
            >
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
             <img
             src="/primexlogo.png" 
              alt="PrimeX Loyalty"
             className="w-25 h-16"
            />
          </div>
          
          <h2 className="text-2xl font-semibold text-gray-800">Forgot Password?</h2>
          <p className="text-gray-600 mt-2">
            No worries, we'll send you reset instructions.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus-2 focus-blue-500 focus-transparent transition duration-200"
              placeholder="Enter your email address"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover-blue-700 focus-2 focus-blue-500 focus-offset-2 transition duration-200 font-medium whitespace-nowrap cursor-pointer"
          >
            Send Reset Instructions
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link
            to="/login"
            className="text-blue-600 hover-blue-800 font-medium transition duration-200 flex items-center justify-center"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
